import { Pipe, PipeTransform } from '@angular/core';
import { DictionaryModel } from '@core/models/dictionary.model';

@Pipe({
  name: 'taskTypeAcronym',
  standalone: true,
  pure: true
})
export class TaskTypeAcronymPipe implements PipeTransform {
  transform(value: DictionaryModel): string {
    return !value 
    ? ''
    : value.Title.split(' ').reduce((acc, item) => acc += item[0].toUpperCase(), "");
  }
}
